import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = getLatestComics(12);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">最新更新</h2>
            <p className="text-sm text-foreground-500">实时追踪 · 热门韩漫最新章节</p>
          </div>
          <div className="flex items-center gap-3">
            <Link
              to="/category/all"
              className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              全部漫画
            </Link>
            <Link
              to="/category/fantasy"
              className="hidden sm:inline text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              奇幻
            </Link>
            <Link
              to="/category/romance"
              className="hidden sm:inline text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              恋爱
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {latest.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-3 md:p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-colors group cursor-pointer"
            >
              <div className="relative w-16 h-20 md:w-18 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-300">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫在线免费阅读最新章节`}
                  className="w-full h-full object-cover"
                />
                {index < 3 && (
                  <div className="absolute top-0 left-0 w-5 h-5 bg-accent-500 flex items-center justify-center">
                    <span className="text-[10px] font-bold text-background-50 dark:text-foreground-950">{index + 1}</span>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                  {comic.title}
                </h3>
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
                  <span className="text-foreground-400">{comic.author}</span>
                  <span className="text-foreground-300">·</span>
                  <span className="text-accent-600 font-medium">更新至{comic.chapters}话</span>
                </div>
                <div className="flex items-center gap-3 mt-1.5">
                  <div className="flex items-center gap-0.5">
                    <i className="ri-eye-line text-foreground-400 text-[10px]"></i>
                    <span className="text-[10px] text-foreground-400">
                      {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
                    </span>
                  </div>
                  <span className="text-[10px] text-foreground-400">{comic.updatedAt}</span>
                </div>
                <div className="flex flex-wrap items-center gap-1 mt-1.5">
                  {comic.tags.slice(0, 2).map(tag => (
                    <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-sm"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}